export function currencyToNumber(currency: string): number {
	if (typeof currency === 'number') return currency;

	const numberString = currency?.replace(/[^\d,-]/g, '')?.replace(',', '.');
	return parseFloat(numberString);
}
